import { useTimeMachine } from '../context/time-machine-context'

export const TimeMachineButton = () => {
	const { setPointValue, is2HTemp, currentTimeValue } = useTimeMachine();
	const timeMachineButton = is2HTemp ? [50, 60, 70, 80] : [10, 20, 30, 40, 50, 60, 70, 80];

	const clickTimeMachineButton = (item: number) => {
		if (currentTimeValue > item) {
			return;
		}
		setPointValue(item);
	}

	return (
		<div className="tm-btn-bar">
			{
				timeMachineButton.map(item => (
					<button
						key={item}
						data-disabled={currentTimeValue > item}
						onClick={() => clickTimeMachineButton(item)}
						className={'btn'}
					>
						<span className="btn__text" >{item}&apos;</span>
					</button>
				))
			}
		</div>
	)
}